import React, {Component} from "react";
import { observer } from "mobx-react";

import OrderMenuListItemView from "./OrderMenuListItemView";
import OrderMenuPagingBottomView from "./OrderMenuPagingBottomView";
import {fn_commonPageSet} from "../../../../../function/FnPage";
import {Link} from "react-router-dom";

@observer
class OrderMenuListView extends Component {
    render() {

        const { rootStore } = this.props;
        const menuData = rootStore.menuStore.getMenuData;
        const groupCode = rootStore.menuStore.getMenuGroupCode;

        let pageStore = rootStore.pageStore.getPagingInfo;
        let menuList = [];
        let sliceList = [];
        for (let i = 0; i < menuData.length; i++) {
            if (menuData[i].tuClsCd == groupCode)
                menuList = menuData[i].prods;
        }
        const totalPage = Math.ceil(menuList.length / 10);

        if( pageStore.max_page != totalPage )
            fn_commonPageSet(rootStore, totalPage);
        sliceList = ( totalPage > 1 )?menuList.slice((pageStore.page_no - 1) * 10, pageStore.page_no * 10):menuList;

        return (

            <div className="section_list">
                <h3>상품 목록</h3>
                <ul className="list_dot">
                    <li>배민, 쿠팡이츠, 요기요 이용 시 각 채널의 주문접수 프로그램에서 별도로 품절처리를 해야합니다.</li>
                    <li>터치키에 등록되어 있으나 상품이 없는 경우, 가맹점웹페이지(웹정보)에서 해당 상품의 모바일 주문 구분값이 [MOBILE] 또는 [공통]인
                        지 확인해주세요.
                    </li>
                </ul>
                <div style={{height:"490px"}}>
                    <ul className="list_cont">
                        {Array.isArray(sliceList) && sliceList.length > 0 ?
                            sliceList.map((menu, index) => (
                                <OrderMenuListItemView key={index+100} rootStore={rootStore} menu={menu} />
                            )) : ''
                        }
                    </ul>
                </div>
                <OrderMenuPagingBottomView rootStore={rootStore} />
                <div className="close">
                    <Link to="/"><button type="button"><span>페이지 닫기</span></button></Link>
                </div>
            </div>
        );
    }
}

export default OrderMenuListView;